module.exports = __webpack_public_path__ + "img/cp1.9a0847b5.jpg";